import { Table } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

export default function InvoiceTableView() {
    return (
        <TableView.Table>
            <Table.Column<Invoice>
                accessorKey="id"
                header="ID"
                size={144}
                cell={({ row }) => <Table.Cells.IDCell id={row.original.custom_id || row.original.id} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<Invoice>
                accessorKey="client_name"
                header="Client"
                size={224}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={true}
                dataType="alphabetical"
            />
            <Table.Column<Invoice>
                accessorKey="state_label"
                header="State"
                size={128}
                cell={({ getValue }) => <Table.Cells.BadgesCell badges={[getValue()]} />}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Invoice>
                accessorKey="status_label"
                header="Status"
                size={176}
                cell={({ getValue }) => <Table.Cells.StatusCell objectType="invoice" status={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Invoice>
                accessorKey="labels"
                header="Labels"
                size={240}
                cell={({ getValue }) => (
                    <Table.Cells.BadgesCell
                        badges={(getValue() as InvoiceLabel[])?.map((label: InvoiceLabel) => label.name)}
                    />
                )}
                enableSorting={false}
                enablePinning={false}
                dataType="other"
                loadingType="badge"
            />
            <Table.Column<Invoice>
                accessorKey="amount_due"
                header="Amt. Due"
                size={128}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<Invoice>
                accessorKey="total"
                header="Total"
                size={144}
                cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                enableSorting={true}
                enablePinning={false}
                dataType="numerical"
                alignment="right"
            />
            <Table.Column<Invoice>
                accessorKey="service_name"
                header="Service"
                size={224}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Invoice>
                accessorKey="service_location_name"
                header="Location Name"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Invoice>
                accessorKey="service_location_address"
                header="Location Address"
                size={288}
                cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="alphabetical"
            />
            <Table.Column<Invoice>
                accessorKey="date_issued"
                header="Issued"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="date_due"
                header="Due Date"
                size={144}
                cell={({ getValue, row }) => (
                    <Table.Cells.DateTimeCell
                        value={getValue()}
                        isDangerous={row.original.state_label === "Overdue"}
                    />
                )}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="last_status_transition_time"
                header="Status Changed"
                size={160}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={false}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="last_modified_at"
                header="Last Modified"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="last_viewed"
                header="Seen"
                size={96}
                cell={({ getValue }) => <Table.Cells.SeenCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="other"
            />
            <Table.Column<Invoice>
                accessorKey="last_sent_at"
                header="Sent"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="last_paid_at"
                header="Paid"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="last_voided_at"
                header="Voided"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
            <Table.Column<Invoice>
                accessorKey="last_forgiven_at"
                header="Forgiven"
                size={144}
                cell={({ getValue }) => <Table.Cells.DateTimeCell value={getValue()} />}
                enableSorting={true}
                enablePinning={false}
                dataType="timing"
            />
        </TableView.Table>
    )
}
